import { type CollaboratorDetails } from "@vega-api/generated/types/collaboratorDetails";
import { m } from "@vega-core/paraglide/messages";
import { TriStateCheckbox } from "@vega-modules/scenes/CoInvestmentsGP/components/DataRoomPermissions/TriStateCheckbox";

import {
  getFundRoleCount,
  type useManageRolesSelection,
} from "../../hooks/useManageRolesSelection";

import { CollaboratorSelectionRow } from "./CollaboratorSelectionRow";

type CollaboratorSelectionStepProps = {
  collaborators: CollaboratorDetails[];
  selection: ReturnType<typeof useManageRolesSelection>;
};

export const CollaboratorSelectionStep = ({
  collaborators,
  selection,
}: CollaboratorSelectionStepProps) => {
  const {
    selectedUserIds,
    toggleUser,
    toggleAllSelectable,
    isAllSelectableSelected,
    isPartiallySelected,
    selectableCount,
  } = selection;

  const getSelectAllCheckedValue = (): boolean | "indeterminate" => {
    if (isAllSelectableSelected) return true;

    if (isPartiallySelected) return "indeterminate";

    return false;
  };
  const selectAllCheckedValue = getSelectAllCheckedValue();

  return (
    <div
      className="flex flex-col gap-2"
      data-testid="manage-roles-selection-step"
    >
      <div className="flex items-center gap-3 px-4 py-3 border-b border-border/secondary">
        <TriStateCheckbox
          ariaLabel={m.settings_collaborators_manageRoles_selectAll({
            count: String(selectableCount),
          })}
          dataTestId="manage-roles-select-all"
          onChange={selectableCount === 0 ? undefined : toggleAllSelectable}
          state={selectAllCheckedValue}
        />
        <span className="body-base-medium text-text/primary">
          {m.settings_collaborators_manageRoles_selectAll({
            count: String(selectableCount),
          })}
        </span>
      </div>
      <div className="flex flex-col max-h-96 overflow-y-auto">
        {collaborators.map((collaborator) => (
          <CollaboratorSelectionRow
            collaborator={collaborator}
            isSelected={selectedUserIds.has(collaborator.id)}
            key={collaborator.id}
            onToggle={() => toggleUser(collaborator.id)}
            roleCount={getFundRoleCount(collaborator)}
          />
        ))}
      </div>
    </div>
  );
};
